type Image = {
  [key: string]: string;
};

const imageAll = import.meta.glob(['./*/*.*', './*.*'], {
  as: 'url',
  eager: true,
});

const IMG: Image = {};

Object.keys(imageAll).forEach((path) => {
  IMG[path.replace(/(\.\/|\.js)/g, '')] = imageAll[path];
});

export default IMG;
